export default {
  initialize: state => ({
    type: 'ACTIVE_ITEM_INITIALIZE',
    state,
  }),
  setActiveItem: activeItem => ({
    type: 'ACTIVE_ITEM_SET_ACTIVE_ITEM',
    activeItem,
  }),
};
